import { buildUtmApiUrl } from './utm-backend-url';

export const resolveUtmIconUrl = (iconValue?: string): string | null => {
  if (!iconValue) return null;
  if (iconValue.startsWith('http://') || iconValue.startsWith('https://')) {
    return iconValue;
  }
  return buildUtmApiUrl(`/files/serve-by-key/${encodeURIComponent(iconValue)}?bucket=public`);
};
